import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './programs-card.scss';

function generateSubtitle(props) {
  const {
    investmentVolume,
    investmentPeriod,
    investmentRate,
    programYearLabel,
    programYear
  } = props;

  const labels = [];

  if (!!investmentVolume) {
    labels.push(`Объем выпуска&nbsp;&mdash; <i>${investmentVolume}&nbsp;млн руб.</i>`);
  }

  if (!!investmentPeriod) {
    labels.push(`Срок обращения&nbsp;&mdash; <i>${investmentPeriod}&nbsp;месяцев</i>`);
  }

  if (!!investmentRate) {
    labels.push(`Доходность инвестора&nbsp;&mdash; <i>${investmentRate}%</i>`);
  }

  if (!!programYear || !!programYearLabel) {
    labels.push(`${programYearLabel} <i>${programYear}</i>`);
  }

  return labels.join('</br>');
}

class ProgramsCard extends PureComponent {
  render() {
    const subtitle = generateSubtitle(this.props);

    return (
      <button type="button" onClick={this.props.onClick}>
        <div className="programs-card">
          <div
            className="programs-card-image"
            style={{ backgroundImage: `url(${this.props.previewImage})` }}
          />

          <h2
            className="programs-card-title"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />

          {(!!subtitle) &&
            <h3
              className="programs-card-subtitle"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          }

          <p
            className="programs-card-text"
            dangerouslySetInnerHTML={{ __html: this.props.previewText }}
          />

          <div className="programs-card-button">
            <div className="btn btn-arrowed">
              Подробнее <span className="icon">→</span>
            </div>
          </div>
        </div>
      </button>
    );
  }
}

ProgramsCard.propTypes = {
  previewImage: PropTypes.string,
  title: PropTypes.string,
  previewText: PropTypes.string,
  investmentVolume: PropTypes.string,
  investmentPeriod: PropTypes.string,
  investmentRate: PropTypes.string,
  programYearLabel: PropTypes.string,
  programYear: PropTypes.string,
  onClick: PropTypes.func
};

export default ProgramsCard;



// WEBPACK FOOTER //
// ./src/components/Programs/ProgramsCard.js